import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'countries';

export class Countries extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
